import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { DeviceDetectorService } from "ngx-device-detector";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";

@Component({
	selector: "app-email-view",
	templateUrl: "./email-view.component.html",
	styleUrls: ["../customer-marketing.style.scss"],
})
export class EmailViewComponent implements OnInit {
	customerKey: string;
	blastKey: string;
	templateKey: string;

	valid: boolean = false;
	venueKey: number;

	constructor(public app: AppService, public deviceService: DeviceDetectorService, private focuslink: FocuslinkService, private route: ActivatedRoute) {}

	ngOnInit(): void {
		this.venueKey = +this.route.snapshot.paramMap.get("venueKey");
		this.customerKey = this.route.snapshot.queryParamMap.get("cid");
		this.blastKey = this.route.snapshot.queryParamMap.get("bid");
		this.templateKey = this.route.snapshot.queryParamMap.get("tid");

		if (this.customerKey && this.blastKey && this.templateKey) {
			this.logVisit();
			this.valid = true;
		}
	}

	async logVisit() {
		const deviceInfo = this.deviceService.getDeviceInfo();
		await this.focuslink.marketingBlastLogView(this.venueKey, this.customerKey, this.templateKey, this.blastKey, JSON.stringify(deviceInfo));
	}
}

//cid={{customerKey}}&bid={{blastKey}}&tid={{templateKey}}
